module.exports = __webpack_public_path__ + "static/media/promocode.a2ca6ad5.svg";